export const PATH = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  BOT: '/bot',
  BOT_MESSAGES: '/bot?tab=messages',
  ENROLL_MFA: '/enroll-mfa',
  MFA: '/mfa',
  PRODUCTCHATBOT: '/products/chatbot',
  PRODUCTCONTENT: '/products/content',
  PRODUCTENRICHMENT: '/products/enrichment',
  PRODUCTSCHEDULING: '/products/scheduling',

  HOME: '/',
  BLOG_GRID: '/blog-grid',
  BLOG_SINGLE: '/blog-single',
  SIGN_UP: '/sign-up',
  EMAIL_VERIFICATION: '/email-verification',
  COMPLETE_PROFILE: '/complete-profile',
  // Was '/onboarding/workspace-setup'. Repointed to the new wow-wizard flow
  // (/onboarding/welcome) so login/signup/auth-callback/no-workspace redirects
  // land users on the new onboarding instead of the old setup form. Existing
  // query string params (?from_login, ?reason, ?workspaceId) still travel
  // through — the welcome page ignores them harmlessly.
  SETUP_WORKSPACE: '/onboarding/welcome',
  WORKFLOW_SELECTION: '/onboarding/workflow-selection',
  AI_ANALYSIS: '/onboarding/ai-analysis',
  ONBOARDING_WOW: '/onboarding/welcome',
  WORKSPACE_INTENT: '/onboarding/workspace-intent',
  CREATE_WORKSPACE: '/onboarding/create-workspace',
  JOIN_WORKSPACE: '/onboarding/join-workspace',
  ONBOARDING_SUBSCRIBE: '/onboarding/subscribe',
  NOT_FOUND: '/404',
  VENDOR_LEADS: '/vendor-leads',
  VENDOR_SETTINGS: '/vendor-leads/settings',
  BOT_LIVE: '/bot-live',
  BOT_SUBSCRIPTION_SUCCESS: '/bot/success',
  IDEAS: '/contents/ideas',
  POSTS: '/contents/posts',
  SETTINGS: '/settings',
  CASE_STUDIES: '/case-studies',
  TEMPLATES: '/contents/templates',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  LOGOUT: '/logout',
  OFFERS: '/offers',
  INTEGRATION: '/integrations',
  SETTINGS_CHAMPIONS: '/settings/champions',
  AGENTS: '/agents',
  VOICE_AI: '/voice-ai',
  SIGNALS: '/signals',
  PROSPECTS: '/prospects',
  MEETINGS: '/meetings',
  OPPORTUNITIES: '/opportunities',
  AUDIENCES: '/audiences',
  AUDIENCE_DETAIL: (id: number | string) => `/audiences/${id}`,
  CAMPAIGNS: '/campaigns',
  // A loop opens in the flow builder like every campaign; ?loop= opens one of its panels. Same rule
  // as mb-server services/loops/loopLinks.js (notification hrefs).
  LOOP: (audienceId: number | string, panel?: 'updates' | 'emails' | 'settings') =>
    `/workflows/${audienceId}${panel ? `?loop=${panel}` : ''}`,
  CAMPAIGNS_TEMPLATES: '/campaigns/templates',
  CAMPAIGNS_RESULTS: '/campaigns/results',
  // mb-frontend#4638 phase 2: the outreach-sequence template CRUD (Campaigns > Templates in the
  // design). Distinct from CAMPAIGNS_TEMPLATES above, which is the pre-existing campaign-launch
  // workflow picker (Custom-made / My Templates) -- do not conflate the two.
  // The Templates list is a tab of /campaigns, not its own page: /campaigns?tab=templates.
  // /campaigns/outreach-templates redirects here so links already shared keep working.
  CAMPAIGNS_OUTREACH_TEMPLATES: '/campaigns?tab=templates',
  CAMPAIGNS_OUTREACH_TEMPLATE: (templateId: number | string) => `/campaigns/outreach-templates/${templateId}`,
  POWER_DIALER: '/power-dialer',
  POWER_DIALER_NEW_SESSION: '/power-dialer/session/new',
  POWER_DIALER_SESSION: (id: string) => `/power-dialer/session/${id}`,
  POWER_DIALER_SESSION_REPORT: (id: string) => `/power-dialer/session/${id}/report`,
  POWER_DIALER_VOICEMAILS: '/power-dialer/voicemails',
  PLAYS: '/plays',
  WORKFLOWS_BUILDER: '/workflows/builder',
  INTERNAL_AGENTS: '/internal-agents',
  WORKFLOWS: '/workflows',
  AI_CONTEXT: '/ai-context',
  AI_SEO: '/ai-seo',
  TASKS: '/tasks',

  // GH#830: Analytics (replaces Dashboard + Results)
  ANALYTICS_OVERVIEW: '/dashboard',
  ADMIN_ANALYTICS: '/analytics/overview',
  ANALYTICS_ACTIVITY: '/analytics/activity',
  /**
   * Activity → Performance → Email, filtered to one campaign across all time. `email_source=all`
   * overrides a saved source choice (e.g. Nurture) that would otherwise hide campaign sends.
   */
  CAMPAIGN_EMAIL_ACTIVITY: (audienceId: number | string) => (
    `/analytics/activity?tab=performance&campaign=email&email_audienceFilter=${audienceId}&email_timeRange=all&email_source=all`
  ),
  /**
   * The same page, opened on whichever channel the campaign actually ran on.
   *
   * Activity's filters are per-channel (`useAnalyticsUrlSync` reads `<channel>_*`), so a link
   * that scopes only the email tab drops the campaign scope the moment the reader switches to
   * LinkedIn. Both channels are scoped here: `UnifiedWorkflowAnalytics` strips the inactive
   * tabs' params on a switch, which leaves the one being switched to still filtered.
   *
   * A Today row carries both channels' volume, so the caller picks the tab from the campaign's
   * own mix — a LinkedIn-only campaign landing on the email tab reads as zero activity.
   */
  CAMPAIGN_ACTIVITY: (audienceId: number | string, channel: 'email' | 'linkedin' = 'email') => (
    `/analytics/activity?tab=performance&campaign=${channel}`
    + `&email_audienceFilter=${audienceId}&email_timeRange=all&email_source=all`
    + `&linkedin_audienceFilter=${audienceId}&linkedin_timeRange=all`
  ),
  ANALYTICS_REVENUE: '/analytics/revenue',

  NEW_DASHBOARD: '/dashboard',

  CHAT: '/chat',
  PRICING: '/pricing',
  PLAYBOOKS: '/playbooks',
  HEYGEN: '/heygen',
};
